module.exports = __webpack_public_path__ + "static/japanese-e2192f82612eeae71bc3422fc624acb1.jpg";